import * as React from 'react';
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import useMediaQuery from '@mui/material/useMediaQuery';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';

import isEmail from 'validator/lib/isEmail';
import isStrongPassword from 'validator/lib/isStrongPassword';

import { Swiper } from 'swiper/react';
import { SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import "./../assets/swiperCss.css";
import 'swiper/css/autoplay';

import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';

import Menu from '@mui/material/Menu';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import DashboardTwoToneIcon from '@mui/icons-material/DashboardTwoTone';

import { createTheme, responsiveFontSizes, ThemeProvider } from '@mui/material/styles';
import { themeResponsive } from "../../theme/responsiveTheme.js";

import AdminMenuComponent from "../../components/admin/AdminMenuComponent.js";

const responsiveTheme = responsiveFontSizes(themeResponsive);

const widthPageSlide = 600;

// --- INI -------  TabPanel Cookies

const cookie_info = "Questo sito utilizza cookie tecnici (ovvero cookie necessari) e con il tuo consenso anche cookie analitici e di profilazione, che utilizzeremo noi e terze parti, rispettivamente necessari a consentire alcune funzionalità fondamentali per il sito, ad ottenere misurazioni delle performances del sito stesso e ove previsti a proporti inserzioni promozionali in linea con i tuoi interessi, come specificato nella cookie policy. Puoi liberamente accettare, rifiutare o personalizzare il tuo consenso: cliccando su ‘Accetta’ acconsenti all’utilizzo di tutti i cookie, compresi i cookie di profilazione anche di terze parti; cliccando su ‘Personalizza’ puoi confermare le tue preferenze dopo aver selezionato le finalità di tuo interesse nel box sotto-riportato, dove è possibile anche visualizzare i dettagli di ogni singola categoria di cookie; cliccando invece su ‘Chiudi e accetta solo cookie necessari’, installerai solo i cookie strettamente necessari, rifiutando di conseguenza tutte le altre tipologie (cookie di profilazione inclusi). Per maggiori informazioni puoi consultare in qualsiasi momento la cookie policy."

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

// --- FIN -------  TabPanel Cookies

const HomePageComponent = ({ loginUserApiRequest, reduxDispatch, setReduxUserState }) => {
  const [validated, setValidated] = useState(false);
  const [loginUserResponseState, setLoginUserResponseState] = useState({
    success: "",
    error: "",
    loading: false,
  });

  const navigate = useNavigate();

  const config = require("../../constants/constants.js")

  const [page, setPage] = useState({});
  const [id, setId] = useState("");
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [description, setDescription] = useState("");
  const [customizedName, setCustomizedName] = useState("");
  const [customizedStreet, setCustomizedStreet] = useState("");
  const [customizedZip, setCustomizedZip] = useState("");
  const [customizedCity, setCustomizedCity] = useState("");
  const [customizedEmail, setCustomizedEmail] = useState("");
  const [customizedTelephone, setCustomizedTelephone] = useState("");
  const [pathImage0, setPathImage0] = useState("");
  const [titleImage0, setTitleImage0] = useState("");
  const [subTitleImage0, setSubTitleImage0] = useState("");
  
  //  const address_marginLeft = "30px";
  const address_marginLeft = "30px";

  // --- INI -------  Confirm Dialog

  const [idCategoryInWorking, setIdCategoryInWorking] = useState("");
  const [nameInWorking, setNameInWorking] = useState("");
  const [openConfirmDialog, setOpenConfirmDialog] = React.useState(false);
  const [open, setOpen] = React.useState(false);

  const [cookieTabActive, setCookieTabActive] = useState("");
  const [value, setValue] = useState(0);

  const [tabAttivo, setTabAttivo] = React.useState('home');

  const [cookiesPolicy, setCookiesPolicy] = useState("");

  const [isCookiesNecessari, setIsCookiesNecessari] = useState(true);
  const [isCookiesFunzionali, setIsCookiesFunzionali] = useState(false);
  const [isCookiesAnalitici, setIsCookiesAnalitici] = useState(false);
  const [isCookiesProfilazione, setIsCookiesProfilazione] = useState(false);

  const switchCookieNecessariHandler = (event) => {
    setIsCookiesNecessari(event.target.checked);
    console.log('[switch] isCookiesNecessari =', isCookiesNecessari)
  };

  const switchCookieFunzionaliHandler = (event) => {
    setIsCookiesFunzionali(event.target.checked);
    console.log('[switch] isCookiesFunzionali =', isCookiesFunzionali)
  };

  const switchCookieAnaliticiHandler = (event) => {
    setIsCookiesAnalitici(event.target.checked);
    console.log('[switch] isCookiesAnalitici =', isCookiesAnalitici)
  };

  const switchCookieProfilazioneHandler = (event) => {
    setIsCookiesProfilazione(event.target.checked);
    console.log('[switch] isCookiesProfilazione =', isCookiesProfilazione)
  };


  const handleClickOpen = () => {
    setOpen(true);
  };

  const popupConfirmConfirm = () => {
    console.log('[PopupConfirmConfirm]')

    //window.location.assign('/admin/categories')
    setOpen(false);
    //window.location.assign('/admin/categories')
  };

  const handlerDialogCookiesClose = () => {
    console.log('[PopupConfirmClose]')
    setOpen(false);
  };

  const ViewConfirmDialog = () => {
    return (
      <Dialog
        open={open}
        onClose={handlerDialogCookiesClose}
        //fullWidth
        //maxWidth="sm"       
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "800px",  // Set your width here
              padding: 0,
            },
          },
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{ background: "#CCE5FF", fontWeight: "bold", color: "#060606" }}>
          <Typography
            sx={{
              color: '#0f4c8e',
              fontFamily: "sans-serif",
              textTransform: 'none',
              fontSize: 18,
              fontWeight: 700,
            }}
          >
            Consenso all'utilizzo dei cookie
          </Typography>
        </DialogTitle>

        <DialogContent>
          {/*          
          <DialogContentText id="alert-dialog-description" >
            &nbsp;
          </DialogContentText>
          <DialogContentText id="alert-dialog-description" >
            Confermi la cancellazione del tipo prodotto <b><i>{nameInWorking}</i></b> ?
          </DialogContentText>
          <DialogContentText id="alert-dialog-description" >
            &nbsp;
          </DialogContentText>
            */}

          <Box
            sx={{
              borderBottom: 2,
              borderColor: 'divider',
            }}
          >
            <Tabs
              size={{ xs: 12, md: 12 }}
              value={value}
              onChange={handleChange}
              indicatorColor='secondary'
              textColor='secondary'
              variant="fullWidth"
              centered
              sx={{
                background: '#fffffa',
              }}
            >
              <Tab
                {...a11yProps(0)}
                label="Uso cookie"
              />
              <Tab label="Dettagli" {...a11yProps(1)} />
              <Tab label="Informazioni" {...a11yProps(2)} />
            </Tabs>
          </Box>
          {/* ------------------------ tab 0 ---------------------- */}
          {/*  Uso cookie                                index 0    */}
          <CustomTabPanel value={value} index={0}>
            <Box
              component="form"
              sx={{ '& > :not(style)': { m: 1 } }}
              noValidate
              autoComplete="off"
            >
              <Typography sx={{ color: 'text.secondary', fontSize: 14, mb: 0 }}>
                {cookie_info}
              </Typography>
            </Box>
          </CustomTabPanel>

          {/* ------------------------ tab 1 ---------------------- */}
          {/*  Dettagli                                  index 1    */}
          <CustomTabPanel value={value} index={1}>

            <Box
              component="form"
              sx={{ '& > :not(style)': { m: 1 } }}
              noValidate
              autoComplete="off"
            >
              <Typography sx={{ color: '#223e7e', fontSize: 16, mb: 0 }}>
                Necessari
              </Typography>
              <Typography sx={{ color: 'text.secondary', fontSize: 14, mb: 0 }}>
                I cookie necessari contribuiscono a rendere fruibile il sito web abilitandone funzionalità di base quali la navigazione sulle pagine e l'accesso alle aree protette del sito. Il sito web non è in grado di funzionare correttamente senza questi cookie.
                I cookie di preferenza consentono al sito web di memorizzare informazioni che ne influenzano il comportamento o l'aspetto, quali la lingua preferita o la località nella quale ti trovi.
              </Typography>

              <Typography sx={{ color: '#223e7e', fontSize: 16, mb: 0 }}>
                Analitici
              </Typography>
              <Typography sx={{ color: 'text.secondary', fontSize: 14, mb: 0 }}>
                I cookie statistici aiutano i proprietari del sito web a capire come i visitatori interagiscono con i siti raccogliendo e trasmettendo relative informazioni.
              </Typography>

              <Typography sx={{ color: '#223e7e', fontSize: 16, mb: 0 }}>
                Profilazione
              </Typography>
              <Typography sx={{ color: 'text.secondary', fontSize: 14, mb: 0 }}>
                I cookie di marketing vengono utilizzati per tracciare i visitatori sui siti web. La finalità è quella di presentare annunci pubblicitari che siano rilevanti e coinvolgenti per il singolo utente e quindi di maggior valore per editori e inserzionisti di terze parti.
              </Typography>

              <Typography sx={{ color: '#223e7e', fontSize: 16, mb: 0 }}>
                Non classificati
              </Typography>
              <Typography sx={{ color: 'text.secondary', fontSize: 14, mb: 0 }}>
                I cookie non classificati sono i cookie che sono in fase di classificazione, insieme ai fornitori di cookie individuali.
              </Typography>

            </Box>

          </CustomTabPanel>

          {/* ------------------------ tab 2 ---------------------- */}
          {/*  Informazioni                              index 2    */}
          <CustomTabPanel value={value} index={2}>

            <Box
              component="form"
              sx={{ '& > :not(style)': { m: 1 } }}
              noValidate
              autoComplete="off"
            >

              <Typography sx={{ color: 'text.secondary', fontSize: 14, mb: 0 }}>
                I cookie sono piccoli file di testo che possono essere installati sui siti web per rendere più efficiente l'esperienza per l'utente.
              </Typography>

              <Typography sx={{ color: 'text.secondary', fontSize: 14, mb: 0 }}>
                La normativa vigente in materia di cookie afferma che possiamo memorizzare i cookie sul tuo dispositivo solo se sono strettamente necessari per il funzionamento del sito stesso. Per tutti gli altri tipi di cookie abbiamo bisogno del tuo consenso.
              </Typography>

              <Typography sx={{ color: 'text.secondary', fontSize: 14, mb: 0 }}>
                Questo sito utilizza infatti diversi tipi di cookie, alcuni dei quali sono collocati da servizi di terzi che compaiono sulle nostre pagine.
              </Typography>

              <Typography sx={{ color: 'text.secondary', fontSize: 14, mb: 0 }}>
                In qualsiasi momento potrai modificare o revocare il tuo consenso accedendo ad un'apposita piattaforma per la gestione dei cookie (CMP: Consent Management Platform), sviluppata in conformità ai principi della normativa vigente sul trattamento dei dati personali, direttamente dalla cookie policy (per IT: cookie policy linkabile) dove potrai anche scoprire di più su chi siamo, come poter contattarci e come trattiamo i dati personali.
              </Typography>

            </Box>

          </CustomTabPanel>

          <Divider />

          <Stack
            sx={{
              paddingTop: 2, paddingBottom: 2, paddingLeft: 0, paddingRight: 0,
              display: 'flex',
              flexDirection: { xs: "row", md: "row" },
              alignItems: "center",
              justifyContent: "center",
              flexWrap: 'wrap'
            }}
          >

            <FormControlLabel
              control={<Switch defaultChecked />}
              checked={isCookiesNecessari}
              onChange={switchCookieNecessariHandler}
              label="necessari"
              disabled
            />

            <FormControlLabel
              control={<Switch defaultChecked />}
              checked={isCookiesFunzionali}
              onChange={switchCookieFunzionaliHandler}
              label="funzionali"
            />

            <FormControlLabel
              control={<Switch defaultChecked />}
              checked={isCookiesAnalitici}
              onChange={switchCookieAnaliticiHandler}
              label="analitici"
            />

            <FormControlLabel
              control={<Switch defaultChecked />}
              checked={isCookiesProfilazione}
              onChange={switchCookieProfilazioneHandler}
              label="profilazione"
            />

          </Stack>

          <Stack
            sx={{
              paddingTop: 1, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              display: 'flex',
              flexDirection: { xs: "row", md: "row" },
              alignItems: "center",
              justifyContent: "center",
            }}
          >

            <Button
              variant="contained"
              size='small'
              onClick={handlerDialogCookiesClose}
              sx={{
                //width: "12ch",
                p: 1,
                m: 1,
              }}
            >
              <Stack
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                spacing={0}
                my={0}                  >

                <Typography
                  sx={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                    color: 'white',
                    fontFamily: 'Roboto',
                    textTransform: 'none',
                    fontSize: 16,
                  }}
                >
                  Accetta
                </Typography>
              </Stack>
            </Button>

            <Button
              variant="contained"
              size='small'
              onClick={handlerDialogCookiesClose}
              sx={{
                //width: "12ch",
                p: 1,
                m: 1,
              }}
            >
              <Stack
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                spacing={0}
                my={0}                  >

                <Typography
                  sx={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                    color: 'white',
                    fontFamily: 'Roboto',
                    textTransform: 'none',
                    fontSize: 16,
                  }}
                >
                  Accetta selezionati
                </Typography>
              </Stack>
            </Button>

            <Button
              variant="contained"
              size='small'
              onClick={handlerDialogCookiesClose}
              sx={{
                //width: "12ch",
                p: 1,
                m: 1,
              }}
            >
              <Stack
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                spacing={0}
                my={0}                  >

                <Typography
                  sx={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                    color: 'white',
                    fontFamily: 'Roboto',
                    textTransform: 'none',
                    fontSize: 16,
                  }}
                >
                  Chiudi e accetta necessari
                </Typography>
              </Stack>
            </Button>

          </Stack>

        </DialogContent>

        <DialogActions>

        </DialogActions>

      </Dialog>
    );
  };

  // --- INI -------  Tab

  function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
  }

  const handleChange = (event, newValue) => {
    console.log('[handleChange] TAB newValue=', newValue);
    if (newValue === 0) {
      //readPageByMenuValue('HOME');
      //window.sessionStorage.setItem('configTabActive', JSON.stringify(0));
    }
    if (newValue === 1) {
      //readPageByMenuValue('STAFF');
      //window.sessionStorage.setItem('configTabActive', JSON.stringify(1));
    }
    if (newValue === 2) {
      //readPageByMenuValue('AREE COMPETENZA');
      //window.sessionStorage.setItem('configTabActive', JSON.stringify(2));
    }
    setValue(newValue);
  };

  // --- FIN -------  Tab

  const getPageByMenuValueApiRequest = async (menuValue) => {
    console.log("[getPageByMenuValueApiRequest] leggo page con menuValue =", menuValue);
    const url = `/api/pages/menuValue/` + menuValue;
    const { data } = await axios.get(url);
    //console.log(`data =`, data);
    return data
  }

  useEffect(() => {
    getPageByMenuValueApiRequest('HOME').then((data) => {
      console.log(`data 1 =`, data);
      setPage(data);
      setTitle(data?.title.text);
      setSubTitle(data?.subTitle.text);
      setDescription(data?.description.text);
      setTabAttivo('home');
      setId(data?._id);
      setCustomizedName(page?.customizedContent.name.text);
      setCustomizedStreet(page?.customizedContent.street.text);
      setCustomizedZip(page?.customizedContent.zip.text);
      setCustomizedCity(page?.customizedContent.city.text);
      setCustomizedEmail(page?.customizedContent.email.text);
      setCustomizedTelephone(page?.customizedContent.telephone.text);
      setPathImage0(data?.images[0].path);
      setTitleImage0(data?.imagesTitle[0].text);
      setSubTitleImage0(data?.imagesSubTitle[0].text);

      setValue(0);    // set TAB=0 per popup Cookies

      //console.log(`id =`, id);
      //console.log(`page?.images =`, page?.images);
      //console.log(`page?.title.text =`, page?.title.text);
      //console.log(`page?.description.text =`, page?.description.text);
      //console.log(`page?.customizedContent =`, page?.customizedContent);
      //console.log(`page?.customizedContent.name.text =`, page?.customizedContent.zip.text);
      //console.log(`images =`, data?.images);
      //console.log(`images =`, data?.images[0].path);
    })
      .catch((er) => {
        console.log(er);
      });
  }, [tabAttivo, id])

useEffect(() => {
    console.log('getItem(cookiesPolicy) = ', window.sessionStorage.getItem('cookiesPolicy'));
    setCookiesPolicy(window.sessionStorage.getItem('cookiesPolicy'));
    if (typeof cookiesPolicy === "string") {
      // già esiste
      console.log("La stringa è valorizzata");
    } else if (cookiesPolicy === null) {
      // null
      console.log("The string is null");
      window.sessionStorage.setItem('cookiesPolicy', JSON.stringify('attivo'));
      //openModal();
      setOpen(true);
    } else {
      // è ???
      console.log("La stringa è ???");
      //openModal();
      setOpen(true);
    }
  }, [cookiesPolicy]);

  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const [loginIcon, setLoginIcon] = React.useState(false);

  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };



  return (
    <>

        {/* 
          <ThemeProvider theme={responsiveTheme}>
        */}

        <Box sx={{ flexGrow: 1 }}>

          <AdminMenuComponent></AdminMenuComponent>

          <Grid container spacing={{ xs: 0, md: 2 }}>

            <Grid
              // isScrollpage
              size={{ xs: 12, md: 12 }}
              padding={{ xs: 0, md: 0 }}
              // isA4page
              //size={{ xs: 12, md: 5 }}
              //padding={{ xs: 0, md: 4 }}
            >

              <Box sx={{ width: { md: { widthPageSlide } } }}>

                <Swiper
                  style={{
                    '--swiper-navigation-color': '#fff',
                    // isScrollpage
                    //
                    // isA4page
                    height: useMediaQuery('(min-width:600px)') ? "500px" : "300px",
                  }}

                  loop={true}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false
                  }}

                  lazy={true}
                  pagination={{
                    clickable: true,
                  }}
                  navigation={true}
                  modules={[Pagination, Navigation, Autoplay]}
                  className="image-dim"
                >

                  <SwiperSlide>
                    <img
                      src={pathImage0}
                      loading="lazy"
                    />
                    <div class="text-overlay">
                      <p>
                        <Typography variant="h6" color='#ffffff'
                          sx={{
                            paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1,
                            p: 0, m: 0,
                          }}
                        >
                          {titleImage0}
                        </Typography>
                      </p>
                      <p>
                        <Typography variant="h7" color='#dfdfde'
                          sx={{
                            paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 1,
                            p: 0, m: 0,
                          }}
                        >
                          {subTitleImage0}
                        </Typography>
                      </p>
                    </div>
                    <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                  </SwiperSlide>

                  {page.images?.map((itemImg, id) => (

                    (id > 0 &&

                      <SwiperSlide>
                        <img
                          src={itemImg.path}
                          loading="lazy"
                        />
                        <div class="text-overlay">
                          <p>
                            <Typography variant="h6" color='#ffffff'
                              sx={{
                                paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1,
                                p: 0, m: 0,
                              }}
                            >
                              {itemImg.title}
                            </Typography>
                          </p>
                          <p>
                            <Typography variant="h7" color='#dfdfde'
                              sx={{
                                paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 1,
                                p: 0, m: 0,
                              }}
                            >
                              {itemImg.subTitle}
                            </Typography>
                          </p>
                        </div>
                        <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                      </SwiperSlide>

                    )
                  ))}

                </Swiper>

              </Box>

            </Grid>

            <Grid
              size={{ xs: 12, md: 10 }}
              paddingTop={{ xs: 0, md: 1 }}
              paddingLeft={1}
              paddingRight={3}
              spacing={0}
            >

              <Stack
                spacing={2}
                // isA4page
                //sx={{ flexDirection: { xs: "column", md: "column" }, paddingTop: { xs: 0, md: 4 }, paddingLeft: 0, paddingRight: 0, }}
                // isScrollpage
                sx={{ flexDirection: { xs: "column", md: "column" }, paddingTop: { xs: 0, md: 0 }, paddingLeft: 1, paddingRight: 0, }}
              >

                <Typography
                  sx={{
                    paddingTop: { xs: 2, md: 0 }, paddingBottom: 0, paddingLeft: { xs: 1, md: 0 }, paddingRight: 0,
                    fontFamily: 'Arial',
                    fontWeight: 500,
                    fontSize: 30,
                    color: 'navy',
                  }}
                >
                  <b>{title}</b>
                </Typography>

                <Typography
                  sx={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 2, paddingRight: 0,
                    fontFamily: 'Arial',
                    fontWeight: 300,
                    fontSize: 20,
                    color: 'navy',
                  }}
                >
                  <em>{subTitle}</em>
                </Typography>

                <Typography
                  sx={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 2, paddingRight: 0,
                    fontFamily: 'Arial',
                    fontWeight: 100,
                    fontSize: 14,
                    color: 'black',
                  }}
                >
                  {description}
                </Typography>

              </Stack>

              <Box
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  // isA4page
                  height: 30
                  // isScrollpage
                  //height: 30
                }}
              />

              <Grid container
                spacing={2}
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,

                }}
              >
                <Grid size={{ xs: 1, md: 1 }}>

                </Grid>

                <Grid size={{ xs: 8, md: 8 }}>

                  <Paper
                    sx={{
                      paddingTop: 2, paddingBottom: 3, paddingLeft: 2, paddingRight: 2,
                      background: '#cce0e6'

                    }}
                    elevation={6}
                  >

                    <Stack
                      padding={1}
                      spacing={2}
                      sx={{
                        flexDirection: { xs: "column", md: "column" },
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 2, paddingRight: 2
                      }}
                    >

                      <Typography
                        sx={{
                          fontFamily: 'Arial',
                          fontWeight: 500,
                          fontSize: 16,
                          color: '#1070c5ff',
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0
                        }}
                      >
                        <b>{customizedName}</b>
                      </Typography>

                      <Typography
                        sx={{
                          fontFamily: 'Arial',
                          fontWeight: 500,
                          fontSize: 14,
                          color: '#1877cbff',
                          paddingTop: 0, paddingLeft: address_marginLeft, paddingRight: 0
                        }}
                      >
                        {customizedStreet}
                      </Typography>

                      <Typography
                        sx={{
                          fontFamily: 'Arial',
                          fontWeight: 500,
                          fontSize: 14,
                          color: '#1877cbff',
                          paddingTop: 0, paddingLeft: address_marginLeft, paddingRight: 0
                        }}
                      >
                        {customizedZip}&nbsp;{customizedCity}
                      </Typography>

                      <Typography
                        sx={{
                          fontFamily: 'Arial',
                          fontWeight: 500,
                          fontSize: 14,
                          color: '#1877cbff',
                          paddingTop: 0, paddingLeft: address_marginLeft, paddingRight: 0
                        }}
                      >
                        {customizedEmail}
                      </Typography>

                      <Typography
                        sx={{
                          fontFamily: 'Arial',
                          fontWeight: 500,
                          fontSize: 14,
                          color: '#1877cbff',
                          paddingTop: 0, paddingLeft: address_marginLeft, paddingRight: 0
                        }}
                      >
                        {customizedTelephone}
                      </Typography>

                      {/* 
                      <Typography
                        sx={{
                          fontFamily: 'Arial',
                          fontWeight: 500,
                          fontSize: 16,
                          color: '#1070c5ff',
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0
                        }}
                      >
                        <b>{customizedName}</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<em>orari</em>
                      </Typography>

                      <Grid container spacing={4}
                        sx={{
                          paddingTop: 0, paddingLeft: 1, paddingRight: 0
                        }}
                      >
                        <Grid item xs={3}>
                          <Typography
                            sx={{
                              fontFamily: 'Arial',
                              fontWeight: 500,
                              fontSize: 14,
                              color: '#1877cbff',
                              paddingTop: 0, paddingLeft: 0, paddingRight: 0
                            }}
                          >
                            Lunedì
                            <br />
                            Martedì
                            <br />
                            Mercoledì
                            <br />
                            Giovedì
                            <br />
                          </Typography>
                        </Grid>

                        <Grid item xs={2}>
                          <Typography
                            sx={{
                              fontFamily: 'Arial',
                              fontWeight: 500,
                              fontSize: 14,
                              color: '#000000',
                              paddingTop: 0, paddingLeft: 0, paddingRight: 0
                            }}
                          >
                            08.30 - 19.00
                            <br />
                            08.30 - 19.00
                            <br />
                            08.30 - 19.00
                            <br />
                            08.30 - 19.00
                            <br />
                          </Typography>
                        </Grid>

                        <Grid item xs={3}>
                          <Typography
                            sx={{
                              fontFamily: 'Arial',
                              fontWeight: 500,
                              fontSize: 14,
                              color: '#1877cbff',
                              paddingTop: 0, paddingLeft: 0, paddingRight: 0
                            }}
                          >
                            Venerdì
                            <br />
                            Sabato
                            <br />
                            Domenica
                            <br />
                          </Typography>
                        </Grid>

                        <Grid item xs={2}>
                          <Typography
                            sx={{
                              fontFamily: 'Arial',
                              fontWeight: 500,
                              fontSize: 14,
                              color: '#000000',
                              paddingTop: 0, paddingLeft: 0, paddingRight: 0
                            }}
                          >
                            08.30 - 19.00
                            <br />
                            09.00 - 12.00
                            <br />
                            chiuso
                            <br />
                          </Typography>

                        </Grid>

                      </Grid>
            */}

                    </Stack>

                  </Paper>

                </Grid>
              </Grid>

              <Box
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  height: 30
                }}
              />

            </Grid>

            < ViewConfirmDialog />

          </Grid>

        </Box>

      {/* 
          </ThemeProvider>
      */}

    </>

  );
};

export default HomePageComponent;
